import { EntityClaimRakurakuHistory } from "../../entity/EntityClaimRakurakuHistory";

export class DtoClaimRakurakuHistorysDeleteRes extends EntityClaimRakurakuHistory {
  public message: string | null = null;
}
